var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gridicons:user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.6668 5.33398C18.0813 5.33398 19.4378 5.89589 20.438 6.89608C21.4382 7.89628 22.0001 9.25283 22.0001 10.6673C22.0001 12.0818 21.4382 13.4384 20.438 14.4386C19.4378 15.4387 18.0813 16.0007 16.6668 16.0007C15.2523 16.0007 13.8957 15.4387 12.8956 14.4386C11.8954 13.4384 11.3335 12.0818 11.3335 10.6673C11.3335 9.25283 11.8954 7.89628 12.8956 6.89608C13.8957 5.89589 15.2523 5.33398 16.6668 5.33398ZM16.6668 26.6673C16.6668 26.6673 27.3335 26.6673 27.3335 24.0007C27.3335 20.8007 22.1335 17.334 16.6668 17.334C11.2001 17.334 6.00012 20.8007 6.00012 24.0007C6.00012 26.6673 16.6668 26.6673 16.6668 26.6673Z",
    fill: "#05CD99"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.3ae0017cc2084f87ce664b3b941c18c8.svg";
export { ForwardRef as ReactComponent };